export const HEIGHT = "730px";
export const OVERLAY_WIDTH = "1332px";
